import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex gap-7 max-h-fit overflow-hidden w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", null, "Read more", -1)
const _hoisted_3 = { class: "h-5/6 flex flex-col-reverse" }
const _hoisted_4 = { class: "flex flex-wrap gap-2 py-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-xl font-bold text-white"
}
const _hoisted_6 = { class: "text-sm font-normal" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "text-xl font-bold"
}

import { ref } from "vue"
  import { User, Company, Answer } from "@/store/newsfeed"
  import { IonItem } from "@ionic/vue"
  import router from "@/router"

  import Avatar from "@/components/template/avatarTemplate.vue"

  // image
  import Ambassador from "@/assets/images/ambassadorship/ambassador.png"

  interface Props {
    postId: string
    answer: Answer
    company: Company
    user: User
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ThoughtLeadership',
  props: {
    postId: {},
    answer: {},
    company: {},
    user: {}
  },
  setup(__props: any) {

const props = __props;

  

  const expandDetails = () => {
    if (router.currentRoute.value.path.includes("company/")) localStorage.setItem("backLink", JSON.stringify({ name: "company", slug: router.currentRoute.value.params.slug }))
    if (router.currentRoute.value.path.includes("workbean-world/")) localStorage.setItem("backLink", JSON.stringify({ name: "world" }))
    router.push(`/workbean-world/thought-leadership/${props.postId}`)
  }

  const readMore = () => {
    localStorage.setItem("backLink", `${router.currentRoute.value.fullPath}`)
    router.push(`/workbean-world/employee-ambassadorship/${props.postId}`)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "bg-center bg-cover bg-no-repeat min-h-[469px] w-[330px] mx-auto rounded-base flex-shrink-0 relative px-2 py-4",
      style: _normalizeStyle({ 'background-image': `url(${_ctx.answer.display_link || _ctx.company.logo || _unref(Ambassador)})` })
    }, [
      _createVNode(_unref(IonItem), {
        class: "dark:text-white text-primary-black font-bold py-2 px-4 w-fit ml-auto rounded-2xl",
        onClick: expandDetails
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answer?.tags, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item,
              class: "px-[5px] py-2 text-white rounded-[5px] font-bold w-fit text-sm",
              style: _normalizeStyle({
              background: _ctx.company?.brand_color ? _ctx.company?.brand_color : '#7442C8',
            })
            }, _toDisplayString(item), 5))
          }), 128))
        ]),
        (_ctx.user)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.user.name.full_name || "Ambassador") + " ", 1),
              _createElementVNode("p", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.user?.employment?.role || "Employee") + " ", 1),
                (_ctx.company?.name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "of " + _toDisplayString(_ctx.company.name), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.company.name) + " Ambassador ", 1))
      ])
    ], 4)
  ]))
}
}

})